import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportingTimeWindow,
  EParamChannelTypeGlobal,
  EReportColumnHeader,
  IReportingSearchTermsTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDASearchTermsReportTableFilters,
  TPPRetailerId,
  TSPSearchTermsReportTableFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingCampaignsTableV3({
  retailerId,
  advertiserId,
  campaignId,
  adGroupId,
  channelType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (TSPSearchTermsReportTableFilters | TDASearchTermsReportTableFilters) &
  TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingSearchTermsTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingSearchTermsTable_${channelType}_${retailerId}_${advertiserId}`

  return useQuery(
    [queryKeyName, { start: startDate, end: endDate, channelType }],
    () => {
      return coreAPIV3
        .retailerReporting()
        .getRetailerSearchTermsReportTable(
          retailerId,
          generateCorrelationId(),
          advertiserId,
          campaignId,
          adGroupId,
          channelType as EParamChannelTypeGlobal,
          sortBy as EReportColumnHeader,
          sortOrder,
          timeWindow as EReportingTimeWindow,
          startDate,
          endDate,
          tzZone || getTimezone(),
          pageLimit,
          pageOffset,
          filterBy,
          filterOperation,
          filterValue,
          name
        )
    },
    { suspense, enabled }
  )
}
